import { WprModel } from '../../wpr-framework/view/deco/WprModel';
import { WprDI_ScopeModel } from '../../wpr-framework/view/di/WprDI_ScopeModel';
import { BaseWindowViewScope } from '../base/BaseWindowViewScope';
import { SecondScopeInfo } from '../../scope/SecondScopeInfo';
import { SettlementService } from '../../service/SettlementService';
import { SettlementContractRequest } from '../../service/service-models/settlement/SettlementContractRequest';
import { PolicyContractInfo } from '../../service/models/policy-contract/policy-contract-info';
import { PaymentInfo } from '../../service/models/payment/payment-info';
import { BasicInfo } from '../../models/BasicInfo';
import { RiskFactorInfo } from '../../service/models/risk-factor/risk-factor-info';
import { SelectPlanInfo } from '../../service/models/select-plan/select-plan-info';
import { LoginInfo } from '../../models/LoginInfo';
import { PolicyHolderInfo } from '../../service/models/policy-holder/policy-holder-info';
import { InsuredInfo } from '../../service/models/insured/insured-info';
import { AuthMailInfo } from '../../service/models/auth-mail/auth-mail-info';
import { TravelerInfo } from '../../models/TravelerInfo';
import { ContractNoticeInfo } from '../../service/models/contract-notice/contract-notice-info';
import { CollateralInfo } from '../../models/CollateralInfo';
import { ContractorInfo } from '../../models/ContractorInfo';
import { PlanInfo } from '../../models/PlanInfo';
import { SpecialProvision } from '../../models/SpecialProvision';
import { OthersInfo } from '../../models/OthersInfo';
import { SettlementContractResult } from '../../service/service-models/settlement/SettlementContractResult';
import { PlanByTravelWL } from '../../service/models/plan-by-travel-wl/plan-by-travel-wl';
import { Coverage } from '../../service/models/coverage/coverage';
import { CollateralDisplayInfo } from '../../service/models/collateral-display/collateral-display-info';
import { WprDI_GlobalScopeModel } from '../../wpr-framework/view/di/WprDI_GlobalScopeModel';
import { CollateralDisplayRequest } from '../../service/service-models/collateral-display/CollateralDisplayRequest';
import { PlanByTravelWLService } from '../../service/PlanByTravelWLService';
import { CollateralDisplayResult } from '../../service/service-models/collateral-display/CollateralDisplayResult';


/**
 * PayPay決済完了後ビュー情報
 */
export class SettlementComponentView extends BaseWindowViewScope<SecondScopeInfo> {
	private readonly EXTRA_COLLKEY_OTA: string 				= 'AT23';		// 	追加保障キー（OTA）
	private readonly EXTRA_COLLKEY_DTA: string 				= 'AT36';		// 	追加保障キー（OTA）

	// モデル  ------------------------------------------------------------------
	@WprDI_ScopeModel('BasicInfo')
	private m_BasicInfo: 		BasicInfo			= null;	// 基本情報
	@WprDI_ScopeModel('RiskFactorInfo')
	private m_RiskFactorInfo:	RiskFactorInfo 		= null;	// リスクファクター情報
	@WprDI_ScopeModel('SelectPlanInfo')
	private m_SelectPlanInfo: 	SelectPlanInfo		= null;	// 選択プラン情報
	@WprDI_ScopeModel('LoginInfo')
	private m_LoginInfo: 		LoginInfo 	 		= null; // ログイン情報
	@WprDI_ScopeModel('PolicyHolderInfo')
	private m_PolicyHolderInfo: PolicyHolderInfo 	= null; // 契約者情報（サービス）
	@WprDI_ScopeModel('InsuredInfoList')
	private m_InsuredInfoList: 	InsuredInfo[]		= null; // 旅行者リスト情報（サービス）
	@WprDI_ScopeModel('AuthMailInfo')
	private m_AuthMailInfo: 	AuthMailInfo 		= null; // 契約者（申込者）情報
	@WprDI_ScopeModel('TravelerInfo')
	private m_TravelerListInfo: TravelerInfo[] 			= null; 					// 旅行者（被保険者）リスト情報
	@WprDI_ScopeModel('ContractNoticeInfo')
	private m_ContractNoticeList: ContractNoticeInfo[] 	= null; 					// 告知事項情報
	@WprDI_ScopeModel('CollateralInfo')
	private m_Collaterals: CollateralInfo[] 			= null;						// 補償表示情報
	@WprDI_ScopeModel('PlanInfo')
	private m_PlanInfo: PlanInfo 						= null;						// プラン情報 
	@WprDI_ScopeModel('SpecialProvision')
	private m_SpecialProvision: SpecialProvision 		= null; 					// 特約・約款情報
	@WprDI_ScopeModel('ContractorInfo')
	private m_ContractorInfo: ContractorInfo 			= null; 					// 契約者（申込者）情報
	@WprDI_ScopeModel('OthersInfo')
	private m_OthersInfo: OthersInfo 					= null; 					// その他情報
	@WprDI_ScopeModel('payment')
	private m_Payment:string							= null;						// 支払い方法
	@WprDI_ScopeModel('paymentType')
	private m_PaymentType:string						= null;						// 支払種別
	@WprDI_GlobalScopeModel('AuthMailId')
	private m_AuthMailId: string							= null;
	// -------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('step7_settlement');
	}
	// --------------------------------------------------------------------------
		
	// サービス  -----------------------------------------------------------------
	private m_SettlementService: SettlementService = new SettlementService(); // 締結サービス
	private m_PlanByTravelWLService: PlanByTravelWLService = new PlanByTravelWLService();
	// --------------------------------------------------------------------------
		
	// override メソッド  --------------------------------------------------------
	/**
	 * ビュー表示通知
	 */
	public onShowView(): void {
		// const req = this.setSettlementReq();
		// this.setInfos();
		this.setGlobalScopeModel('location', '/step5_personal-information');
		this.refreshInfos();
		let orderId: string = this.FW.getUrlParam('orderId');
		const req: SettlementContractRequest = new SettlementContractRequest();
		req.paymentInfo = new PaymentInfo();
		req.paymentInfo.orderId = orderId;
		this.m_SettlementService.redirectComplete(this, req, (result) => {
			this.m_LoginInfo.loginId		= result.bookingNo;
			let polNums: string = '';
			for (let i: number = 0; i < result.policyNumberList.length; i++) {
				polNums = polNums + result.policyNumberList[i];
				if (i + 1 !== result.policyNumberList.length)
					polNums = polNums + ', ';
			}
			this.m_BasicInfo.contractNumber = polNums;

			// ScopeModel設定
			this.setBasicInfo(result);
			this.setContractorInfo(result);
			this.setInsuredInfo(result);
			this.setContractNoticeInfo(result);
			this.setPlanInfo(result);
			
			const collateralReq = this.getCollateralReq(result.applicationDate);
			this.m_PlanByTravelWLService.getCollateralDisplay(this, collateralReq, (result2) => {
				this.setCollateralRes(result2);
				this.refreshModel();	
				this.pushPath('/step8_make-contract');
			});
		});
		this.refreshView();
	}
	// --------------------------------------------------------------------------

	// private ------------------------------------------------------------------
	private refreshInfos(): void {
		this.m_BasicInfo = new BasicInfo();
		this.m_PlanInfo = new PlanInfo();
		this.m_LoginInfo = new LoginInfo();
		this.m_SpecialProvision = new SpecialProvision();
		this.m_ContractNoticeList = [];
		this.m_OthersInfo = new OthersInfo();
		this.m_RiskFactorInfo = new RiskFactorInfo();
		this.m_SelectPlanInfo = new SelectPlanInfo();
		this.m_InsuredInfoList = [];
		this.m_PolicyHolderInfo = new PolicyHolderInfo();
		this.m_AuthMailInfo = new AuthMailInfo();
		this.m_TravelerListInfo = [];
		this.m_Collaterals = [];
		this.m_ContractorInfo = new ContractorInfo();
	}

	private setBasicInfo(result: SettlementContractResult): void {
		this.m_BasicInfo.plan = result.plansByWhiteLabel[0].planName;
		this.m_BasicInfo.insuranceFee = result.plansByWhiteLabel[0].totalPremium;
		this.m_BasicInfo.applicationDate = this.convertDate(result.applicationDate);
		const startDate = this.convertDate(result.riskFactorInfo.startDate);
		const endDate = this.convertDate(result.riskFactorInfo.endDate);
		this.m_BasicInfo.insurancePeriod = startDate + '～' + endDate;
		this.setScopeModel('BasicInfo', this.m_BasicInfo);
		this.m_RiskFactorInfo = result.riskFactorInfo;
		this.setScopeModel('RiskFactorInfo', this.m_RiskFactorInfo);
		this.setGlobalScopeModel('ProductCode', this.m_RiskFactorInfo.companyProductCode);
		this.m_AuthMailId = result.authMailId;
		this.setGlobalScopeModel('AuthMailId', this.m_AuthMailId);
		this.m_OthersInfo.agency = result.agency;
		this.setScopeModel('OthersInfo', this.m_OthersInfo);
		// PayPayのみ
		this.setScopeModel('paymentType', 'IC');
		this.setScopeModel('payment', 'payment_paypay');
		this.setScopeModel('LoginInfo', this.m_LoginInfo);
	}

	private setContractorInfo(result: SettlementContractResult): void {
		this.m_PolicyHolderInfo = result.policyContractInfo.policyHolderInfo;
		this.setScopeModel('PolicyHolderInfo', this.m_PolicyHolderInfo);
		if (this.m_PolicyHolderInfo.address2 === null)
			this.m_ContractorInfo.address = this.m_PolicyHolderInfo.address1;
		else
			this.m_ContractorInfo.address = this.m_PolicyHolderInfo.address1 + ' ' + this.m_PolicyHolderInfo.address2;
		this.m_ContractorInfo.address1 = this.m_PolicyHolderInfo.address1;
		this.m_ContractorInfo.address2 = this.m_PolicyHolderInfo.address2;
		this.m_ContractorInfo.dateOfBirth = this.m_PolicyHolderInfo.dateOfBirth;
		const date: Date = new Date(Date.parse(this.m_ContractorInfo.dateOfBirth));
		this.m_ContractorInfo.year = date.getFullYear().toString();
		this.m_ContractorInfo.month = (date.getMonth() + 1).toString();
		this.m_ContractorInfo.date = date.getDate().toString();
		this.m_ContractorInfo.gender = this.m_PolicyHolderInfo.gender;
		this.m_ContractorInfo.firstName = this.m_PolicyHolderInfo.firstName;
		this.m_ContractorInfo.lastName = this.m_PolicyHolderInfo.surName;
		this.m_ContractorInfo.mailAddress = this.m_PolicyHolderInfo.mailAddress;
		this.m_ContractorInfo.name = this.m_PolicyHolderInfo.surName + ' ' + this.m_PolicyHolderInfo.firstName;
		this.m_ContractorInfo.romanName = this.m_PolicyHolderInfo.surNameKana + ' ' + this.m_PolicyHolderInfo.firstNameKana;
		this.m_ContractorInfo.romanFirstName = this.m_PolicyHolderInfo.firstNameKana;
		this.m_ContractorInfo.romanLastName = this.m_PolicyHolderInfo.surNameKana;
		this.m_ContractorInfo.postalCode = this.m_PolicyHolderInfo.postCode;
		this.m_ContractorInfo.prefecture = this.m_PolicyHolderInfo.prefecture;
		this.m_ContractorInfo.tel = this.m_PolicyHolderInfo.phoneNumber;
		this.setScopeModel('ContractorInfo', this.m_ContractorInfo);
	}

	private setInsuredInfo(result: SettlementContractResult): void {
		this.m_InsuredInfoList = result.policyContractInfo.insuredInfoList;
		this.setScopeModel('InsuredInfoList', this.m_InsuredInfoList);
		for (let info of result.policyContractInfo.insuredInfoList) {
			const traveller: TravelerInfo = new TravelerInfo();
			traveller.dateOfBirth = new Date(Date.parse(info.dateOfBirth));
			traveller.year = traveller.dateOfBirth.getFullYear().toString();
			traveller.month = (traveller.dateOfBirth.getMonth() + 1).toString();
			traveller.date = traveller.dateOfBirth.getDate().toString();
			traveller.gender = info.gender;
			traveller.romanFirstName = info.firstNameKana;
			traveller.romanLastName = info.surNameKana;
			traveller.romanName = info.surNameKana + ' ' + info.firstNameKana;
			this.m_TravelerListInfo.push(traveller);
		}
		this.setScopeModel('TravelerInfo', this.m_TravelerListInfo);
		this.m_BasicInfo.insuranceFee = result.plansByWhiteLabel[0].totalPremium * result.policyContractInfo.insuredInfoList.length;
	}

	private setPlanInfo(result: SettlementContractResult): void {
		// 1プランのみ
		const plan: PlanByTravelWL = result.plansByWhiteLabel[0];
		this.m_SelectPlanInfo.planCode = plan.planCode;
		this.m_SelectPlanInfo.totalPremium = plan.totalPremium;
		this.setScopeModel('SelectPlanInfo', this.m_SelectPlanInfo);
		this.m_PlanInfo.planCode = plan.planCode;
		this.m_PlanInfo.planName = plan.planName;
		this.m_PlanInfo.summary = plan.planSummary;
		this.m_PlanInfo.totalPremium = plan.totalPremium;
		this.setScopeModel('PlanInfo', this.m_PlanInfo);
		// // 担保情報
		// let collateralDisplaySize: number = result.collateralDisplayInfoList.length;
		// for (let i = 0; i < collateralDisplaySize; i++) {
		// 	let collateral = new CollateralInfo();
		// 	collateral.collateralKey 			= result.collateralDisplayInfoList[i].collateralKey;
		// 	collateral.collateralDescription 	= result.collateralDisplayInfoList[i].collateralDescription;
		// 	if (collateral.collateralKey === this.EXTRA_COLLKEY_OTA)
		// 		collateral.collateralDescription = this.insertBr(collateral.collateralDescription);
		// 	collateral.displayCollateralName 	= result.collateralDisplayInfoList[i].displayCollateralName;
		// 	collateral.collateralName 			= result.collateralDisplayInfoList[i].collateralShortName;
		// 	collateral.collateralAmount 		= this.toJPUnit(plan.coverages[i].coverageAmount);
		// 	this.m_Collaterals.push(collateral);
		// }
		// this.setScopeModel('CollateralInfo', this.m_Collaterals);
		// this.setListData('CollateralInfo', this.m_Collaterals);
		// const covMap: Map<string, string> = new Map<string, string>();
		// for (let cov of plan.coverages) {
		// 	if (!covMap.has(cov.coverageCd))
		// 		covMap.set(cov.coverageCd, cov.coverageAmount);
		// }
		// const colDispList: CollateralDisplayInfo[] = result.collateralDisplayInfoList;
		// for (let colDisp of colDispList) {
		// 	const addInfo: CollateralInfo = new CollateralInfo();
		// 	addInfo.collateralKey = colDisp.collateralKey;
		// 	addInfo.collateralName = colDisp.collateralShortName;
		// 	addInfo.displayCollateralName = colDisp.displayCollateralName;
		// 	addInfo.collateralDescription = colDisp.collateralDescription;
		// 	addInfo.collateralAmount = covMap.get(colDisp.collateralKey);
		// 	this.m_Collaterals.push(addInfo);
		// }
		// this.setScopeModel('CollateralInfo', this.m_Collaterals);
	}

	private setContractNoticeInfo(result: SettlementContractResult): void {
		this.m_ContractNoticeList = result.contractNoticeInfoList;
		this.setScopeModel('ContractNoticeInfo', this.m_ContractNoticeList);
	}

	/**
	 * CollateralDisplayResult値取得
	 * @param collateralRes 
	 */
	private setCollateralRes(collateralRes: CollateralDisplayResult) {
		let collateralDisplaySize: number = collateralRes.collateralDisplayInfoList.length;
		this.m_Collaterals = [];
		const colDispList = collateralRes.collateralDisplayInfoList.sort((n1, n2) => {
			if (n1.orderNo > n2.orderNo)
				return 1;
			if (n1.orderNo < n2.orderNo)
				return -1;
			return 0;
		});
		let isExtra: boolean = false;
		for (let i = 0; i < collateralDisplaySize; i++) {
			let collateral = new CollateralInfo();
			collateral.collateralKey 			= colDispList[i].collateralKey;
			collateral.collateralDescription 	= colDispList[i].collateralDescription;
			if (collateral.collateralKey === this.EXTRA_COLLKEY_OTA) {
				isExtra = true;
				collateral.collateralDescription = this.insertBr(collateral.collateralDescription);
			}
			else if (collateral.collateralKey === this.EXTRA_COLLKEY_DTA) {
				isExtra = true;
			}
			collateral.displayCollateralName 	= colDispList[i].displayCollateralName;
			collateral.collateralName 			= colDispList[i].collateralShortName;
			// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
			// collateral.collateralAmount 		= this.toJPUnit(colDispList[i].coverageAmount);
			// 無制限はそのまま表示
			if(colDispList[i].coverageAmount.includes('無制限') == true)
				collateral.collateralAmount 	= "無制限";
			else
				collateral.collateralAmount 	= this.toJPUnit(colDispList[i].coverageAmount);
			// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
			this.m_Collaterals.push(collateral);
		}
		this.setScopeModel('CollateralInfo', this.m_Collaterals);
		this.m_SpecialProvision.specialProvision = collateralRes.specialProvision;
		this.setScopeModel('SpecialProvision', this.m_SpecialProvision);
		this.m_BasicInfo.plan = collateralRes.planName;
		if (isExtra)
			this.m_BasicInfo.plan += ' + オプション'; 
		this.setScopeModel('BasicInfo', this.m_BasicInfo);
	}
	
	/**
	 * brタグ挿入
	 */
	private insertBr(collDesc: string): string {
		if (collDesc.includes('<br />') === false) {
			const st = collDesc.slice(0,31);
			const br = '<br />';
			const en = collDesc.slice(31);
			return st+br+en;
		}
		return collDesc;
	}

	/**
	 * 日付「YYYY/MM/dd」を「YYYY年MM月dd日」に変換
	 * 　例：2020/04/31　→　2020年4月31日
	 * @param date 
	 */
	private convertDate(date: string): string {
		return date.replace(/\/0/g, '/').replace(/(\d+)\/(\d+)\/(\d+)/g , '$1年$2月$3日' );
	}
	
	/**
	 * CollateralDisplayRequest値セット
	 * @param collateralReq 
	 * @param riskFactorInfo 
	 * @param paymentInfo 
	 */
	private getCollateralReq(applicationDate: string): CollateralDisplayRequest {
		let collateralReq: CollateralDisplayRequest = new CollateralDisplayRequest();
		const today = new Date(Date.parse(applicationDate));
		collateralReq.riskFactorInfo = this.m_RiskFactorInfo;
		collateralReq.riskFactorInfo.startDate = this.dateFormat(collateralReq.riskFactorInfo.startDate);
		collateralReq.riskFactorInfo.endDate = this.dateFormat(collateralReq.riskFactorInfo.endDate);
		collateralReq.transactionDate = this.dateToString(today);
		collateralReq.planCode = this.m_SelectPlanInfo.planCode;
		collateralReq.paymentInfo = new PaymentInfo();
		return collateralReq;
	}
	
	/**
	 * 日付「YYYY/MM/DD」を「YYYY-MM-DD」に変換
	 * @param date 
	 */
	private dateFormat(date: string): string {
		return date.replace(/(\d+)\/(\d+)\/(\d+)/g, '$1-$2-$3');
	}
	
	/**
	 *  Date型 → string型変換処理
	 * @returns 例： '2020-01-01 15:00:00+0900'
	 */
	private dateToString(date: Date): string {
		let year 	= date.getFullYear();
		let month 	= ('00' + (date.getMonth() + 1)).slice(-2);
		let day 	= ('00' + date.getDate()).slice(-2);
		let hour 	= ('00' + date.getHours()).slice(-2);
		let minute 	= ('00' + date.getMinutes()).slice(-2);
		let second 	= ('00' + date.getSeconds()).slice(-2);
		return `${year}-${month}-${day} ${hour}:${minute}:${second}+0900`;
	}
	// --------------------------------------------------------------------------

	private deepCopyObj(from: any, to: any) {
		let copy;

		// Handle the 3 simple types, and null or undefined
		if (from === null || typeof from !==  'object') return from;
	
		// Handle Date
		if (from instanceof Date) {
			to = new Date();
			to.setTime(from.getTime());
			return to;
		}
	
		// Handle Array
		if (from instanceof Array) {
			to = [];
			for (let i = 0, len = from.length; i < len; i++) {
				to[i] = this.deepCopyObj(from[i], to[i]);
			}
			return copy;
		}
	
		// Handle Object
		if (from instanceof Object) {
			copy = {};
			for (let attr in from) {
				// eslint-disable-next-line no-prototype-builtins
				if (from.hasOwnProperty(attr)) to[attr] = this.deepCopyObj(from[attr], to[attr]);
			}
			return copy;
		}
	}
}
